import webAiWidgetRouteGuard from '@/utils/routeGuards/webAIWidgetRouteGuard';

const routes = [
  {
    path: '/online-presence/web-ai-widget',
    name: 'online-presence-web-ai-widget',
    component: () => import(/* webpackChunkName: "WebAIWidgetPage" */ './views/WebAIWidgetPage.vue'),
    meta: {
      i18n: 'web-ai-widget-pov',
      pageNameEn: 'Web AI Widget',
    },
    beforeEnter: webAiWidgetRouteGuard,
  },
  {
    path: '/online-presence/web-ai-widget/history/:conversation_uid',
    name: 'online-presence-web-ai-widget-history-conversation',
    component: () => import(/* webpackChunkName: "WebAIWidgetPage" */ './views/WebAIWidgetPage.vue'),
    meta: {
      i18n: 'web-ai-widget-pov',
      pageNameEn: 'Web AI Widget Conversation',
    },
    beforeEnter: webAiWidgetRouteGuard,
  },
  {
    path: '/online-presence/web-ai-widget/website-widget-settings',
    name: 'online-presence-website-widget-settings',
    component: () => import(/* webpackChunkName: "WebAIWidgetEditor" */ './views/WebAIWidgetEditor.vue'),
    props: { mode: 'website_widget' },
    meta: {
      i18n: 'web-ai-widget-pov',
      pageNameEn: 'Website AI Widget Settings',
    },
    beforeEnter: webAiWidgetRouteGuard,
  },
];

export default routes;
